import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { CoreMappingsApi } from '../api/core-mappings.api';
import { CoreMappingsUploadResponseDto } from '../api/dtos/core-mappings.dto';
import { CoreMappingsBuyer } from '../state/core-mappings/core-mappings-state.model';

@Injectable({ providedIn: 'root' })
export class CoreMappingsService {
  private readonly _api = inject(CoreMappingsApi);

  public buyers(): Observable<CoreMappingsBuyer[]> {
    return this._api
      .getBuyers()
      .pipe(
        map(({ company }) =>
          company.map(({ id, name }) => ({ id: String(id), name })),
        ),
      );
  }

  public uploadMappings(
    file: File,
    buyerId: string,
  ): Observable<CoreMappingsUploadResponseDto> {
    return this._api.uploadMappings(file, buyerId);
  }

  public downloadMappings(buyerId: string): Observable<Blob> {
    return this._api.downloadMappings(buyerId);
  }
}
